"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _Hint = _interopRequireDefault(require("../../../../Hint/Hint"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var ValidationMessagesGroup = function ValidationMessagesGroup(props) {
  return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: props.validationMessages.sort(function (messageA, messageB) {
      return ((messageA === null || messageA === void 0 ? void 0 : messageA.text) || "") > ((messageB === null || messageB === void 0 ? void 0 : messageB.text) || "") ? -1 : 1;
    }).map(function (validationMessage) {
      return (0, _jsxRuntime.jsx)(_Hint.default, __assign({
        type: validationMessage.type
      }, {
        children: (0, _jsxRuntime.jsx)("span", {
          dangerouslySetInnerHTML: {
            __html: validationMessage.text || ""
          }
        })
      }), JSON.stringify(validationMessage));
    })
  });
};
var _default = ValidationMessagesGroup;
exports.default = _default;